import { useMemo } from 'react';
import CustomTable from '../../../../shared/components/CustomTable';
import type { GroupMember } from '../../../../services/GroupManager/groupManager.service';
import { buildColumns, GroupMemberAction, tableBodyHeight, TABLE_MIN_WIDTH_PX } from './columns';
import styles from './GroupTables.module.scss';

interface GroupTablesProps {
  members: GroupMember[];
  groups: Array<{ id: number; name: string }>;
  currentGroupId: number;
  onAction: (action: GroupMemberAction, member: GroupMember, anchor: HTMLElement | null, targetGroupId?: number) => void;
}

const GroupTables = ({ members, groups, currentGroupId, onAction }: GroupTablesProps) => {
  const columns = useMemo(
    () => buildColumns(groups, currentGroupId, onAction),
    [currentGroupId, groups, onAction],
  );

  return (
    <CustomTable<GroupMember>
      className={styles.groupsTable}
      rowKey="id"
      dataSource={members}
      columns={columns}
      pagination={false}
      tableLayout="fixed"
      scroll={{ x: TABLE_MIN_WIDTH_PX, y: tableBodyHeight(members.length) }}
      locale={{ emptyText: <p className={styles.emptyState}>No users assigned to group</p> }}
      showSorterTooltip={false}
    />
  );
};

export default GroupTables;
